/* eslint-disable import/no-dynamic-require */

import {
    combineReducers
} from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import {
    setLocale, syncTranslationWithStore, I18n, i18nReducer, loadTranslations,
} from 'react-redux-i18n';
import {
    cs_cz, en_cz, de_ch, en_ch, en_us, fr_ca, en_ca, hu_hu, en_hu, pl_pl, en_pl, en_si, sl_si, sv_se, en_se, da_dk, en_dk, fi_fi, en_fi, nn_no, en_no
} from '@root/public/localization';
import { getLanguageCode } from '@helpers/languages';
import appSliceReducer from './slices/appSlice';
import { api } from './services/api';
import { setupListeners } from '@reduxjs/toolkit/query';

export const rootReducer = combineReducers({
    i18n: i18nReducer,
    app: appSliceReducer,
    [api.reducerPath]: api.reducer,
});

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(api.middleware),
});
setupListeners(store.dispatch);
syncTranslationWithStore(store);
// @ts-ignore
I18n.setHandleMissingTranslation(() => '');

const transObj = {
    'cs-cz': cs_cz.default,
    'en-cz': en_cz.default,
    'en-ch': en_ch.default,
    'de-ch': de_ch.default,
    'en-us': en_us.default,
    'en-gb': en_us.default,
    'en-ie': en_us.default,
    'fr-ca': fr_ca.default,
    'en-ca': en_ca.default,
    'hu-hu': hu_hu.default,
    'en-hu': en_hu.default,
    'pl-pl': pl_pl.default,
    'en-pl': en_pl.default,
    'en-si': en_si.default,
    'sl-si': sl_si.default,
    'sv-se': sv_se.default,
    'en-se': en_se.default,
    'da-dk': da_dk.default,
    'en-dk': en_dk.default,
    'nn-no': nn_no.default,
    'en-no': en_no.default,
    'fi-fi': fi_fi.default,
    'en-fi': en_fi.default,
};
const langKey = getLanguageCode();
store.dispatch(loadTranslations(transObj));
store.dispatch(setLocale(langKey));
export default store;

export type AppStore = typeof store
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
